import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';

import { makeStyles } from '@mui/styles';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import FormLabel from '@mui/material/FormLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';

import Validator, { checkValidity, useValidate } from '../../../components/validator';

import IncidentService, { MitreContext } from '../../../data/incident-service';


const useStyles = makeStyles(theme => ({
    card: {
        maxWidth: 345,
    },
    fullWidth: {
        width: '100%',
    },
}));

const CreateIncident = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const [incident, setIncident] = useState({
        name: '',
        data: {
            description: '',
            severity: 1
        },
    });
    const incidentForm = useValidate({});

    const handleUpdateName = (e, validID, valid) => {
        incidentForm.set({ ...incidentForm.get(), [validID]: valid });

        setIncident({
            ...incident,
            name: e.target.value,
        });
    };

    const handleUpdateDescription = (e) => {
        const i = { ...incident };
        i.data.description = e.target.value;
        setIncident(i);
    };

    const handleUpdateSeverity = (e) => {
        const i = { ...incident };
        i.data.severity = e.target.value;
        setIncident(i);
    };

    const handleCreateIncident = () => {
        IncidentService.create(incident).then(res => {
            toast.success('Incident created successfully.');
            navigate(-1);
        }, err => {
            console.error(err);
            if(err.match('unique')) {
                toast.error('Unable to create incident: duplicate name, incident names must be unique');
            } else {
                toast.error('Unable to create incident: ' + err);
            }
        });
    };

    const handleCancel = () => {
        navigate(-1);
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} lg={8}>
                <Paper elevation={3}>
                    <Box p={3} mt={2}>
                        <Box>
                            <Validator
                                valueType="validNameCharacter"
                                errorText="Name cannot contain special characters and cannot be empty"
                                fullWidth
                                label="Incident Name"
                                value={incident.name}
                                onChange={handleUpdateName}
                            />
                        </Box>
                        <Box mt={3}>
                            <FormLabel>Severity</FormLabel>
                            <Select className={classes.fullWidth} value={incident.data.severity} onChange={handleUpdateSeverity}>
                                <MenuItem value={1}>1</MenuItem>
                                <MenuItem value={2}>2</MenuItem>
                                <MenuItem value={3}>3</MenuItem>
                                <MenuItem value={4}>4</MenuItem>
                            </Select>
                        </Box>
                        <Box mt={3}>
                            <TextField
                                fullWidth
                                label="Incident description"
                                value={incident.data.description}
                                onChange={handleUpdateDescription}
                                multiline
                                minRows={4}
                                maxRows={4}
                            />
                        </Box>
                        <Box mt={3} display="flex" justifyContent="flex-end">
                            <Box ml={2}>
                                <Button variant="contained" color="secondary" onClick={handleCancel}>Cancel</Button>
                            </Box>
                            <Box ml={2}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleCreateIncident}
                                    disabled={!checkValidity(incidentForm.get())}
                                >Create</Button>
                            </Box>
                        </Box>
                    </Box>
                </Paper>
            </Grid>
        </Grid>
    );
};

export default CreateIncident;
